import React from 'react';
import { GenericCollection, JSONLD } from 'react-structured-data';
import { DeliveryMethod, ImageObject, Offer, Product } from './MicrodataComponents/index';
import NormalizeAvailability from './Normalizers/Availability';
import DeliveryMethodDescription from './Normalizers/DeliveryMethodDescription';

/* Interfaces */
interface ProductMicrodataProps {
  countryCode?: string;
  currencyIso?: string;
  freeShipping?: boolean;
  image?: string;
  isOutOfStock?: boolean;
  price?: string;
  productName?: string;
}

/* Helpers */
const createOffer = (
  price: string,
  currencyIso: string,
  isOutOfStock: boolean,
  countryCode: string,
  freeShipping: boolean,
): React.ReactNode => (
  <GenericCollection type="offers">
    <Offer
      availability={NormalizeAvailability(isOutOfStock)}
      eligibleRegion={countryCode}
      price={price}
      priceCurrency={currencyIso}
    >
      <GenericCollection type="availableDeliveryMethod">
        <DeliveryMethod description={DeliveryMethodDescription(freeShipping)} />
      </GenericCollection>
    </Offer>
  </GenericCollection>
);

const getImage = (image: string): React.ReactNode => {
  if (!image) {
    return null;
  }

  return (
    <GenericCollection type="image">
      <ImageObject url={image} />
    </GenericCollection>
  );
};

/* Components */
export const ProductMicrodata: React.FC<ProductMicrodataProps> = ({
  productName,
  image,
  isOutOfStock,
  countryCode,
  freeShipping,
  price,
  currencyIso,
}) => {
  if (
    !productName ||
    !image ||
    isOutOfStock === undefined ||
    !countryCode ||
    freeShipping === undefined ||
    !price ||
    !currencyIso
  ) {
    return null;
  }

  return (
    <JSONLD dangerouslyExposeHtml>
      <Product name={productName}>
        {getImage(image)}
        {createOffer(price, currencyIso, isOutOfStock, countryCode, freeShipping)}
      </Product>
    </JSONLD>
  );
};
